import React from 'react';
import './cn-demo-rect.scss';
const CnDemoRect = (props) => {
    return (React.createElement("div", { className: "cn-ui-m-demo-rect", style: props.style }, props.children));
};
export default CnDemoRect;
